module.exports = __webpack_public_path__ + "media/images/fedex-2518205b5ca8de5b693f2e44b4467e55.png";